<template>
  <surround
    :surround-image="surroundImage"
    :title="title"
    :back-link="backLink"
  >
    <div
      v-if="loadedItems"
      class="plantfluencer"
    >
      <h1>{{ item.name }}</h1>
      <vue-plyr
        v-if="item.video"
        ref="plyrinstance"
        :options="{fullscreen: { enabled: true }, controls: ['play-large', 'play', 'progress', 'current-time', 'fullscreen']}"
      >
        <video :src="item.video" />
      </vue-plyr>

      <ContentText>
        <!-- eslint-disable vue/no-v-html -->
        <div v-html="item.content" />
        <!-- eslint-enable -->
      </ContentText>
    </div>
    <p v-else>
      Loading...
    </p>
  </surround>
</template>

<script>
import Vue from 'vue'
import VuePlyr from 'vue-plyr'
Vue.use(VuePlyr)

// import InspirationMap from './InspirationMap.vue'
export default {
  name: 'Plantfluencer',
  props: {
    plantfluencer: {
      type: String,
      required: true
    },
    surroundImage: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    backLink: {
      type: [String, Object, Boolean],
      default: false
    }
  },
  data() {
      return {
          loadedItems: false
      }
  },
  computed: {
    item() {
      return this.loadedItems ? this.$store.getters.itemsDict.plantfluencer[this.plantfluencer] : {}
    }
  },
  beforeMount() {
    this.$store.dispatch('refreshItems', 'plantfluencer').then(() => {
      this.loadedItems = true
    })
  }
}
</script>

<style lang="scss" scoped>
.plantfluencer {
  @include flex-vertical;
  @include flex-fill-vertical;
}
</style>
